import React, { useEffect, useState, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavCenter.css';
import { generateDynamicCSS } from '../../../ComponentsMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import CTAButton from '../../CTAButton/CTAButton';
import { createNavInstance } from '../../../Models/Nav';
import CTAPrimaryButton from '../../CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import LanguageSwitcher from '../../LanguageSwitcher';
import NavSearch from '../NavSearch/NavSearch';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import { refreshAosLite } from '../../../Services/Animations/aosLite';

const NavCenter = () => {
    const { i18n } = useTranslation();
    const [navInstance, setNavInstance] = useState(createNavInstance());
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuItems, setMenuItems] = useState([]);
    const [currentStyle, setCurrentStyle] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [animation, setAnimation] = useState(null);
    // Get current language from i18n
    const currentLanguage = i18n.language;
    const [animationLoaded, setAnimationLoaded] = useState(false);
    const [navSettings, setNavSettings] = useState(navInstance.getSettings());
    // Memoized function to load navigation data
    const loadNavigationData = useCallback(async (language) => {
        try {
            setIsLoading(true);
            
            await navInstance.load(language);
            console.log("navInstance",navInstance.getMenuItems())

            const loadedMenuItems = navInstance.getMenuItems().sort((a, b) => Number(a.order) - Number(b.order));
            console.log("navInstance",navInstance.getMenuItems().sort(c=>c.order))

            const loadedStyles = navInstance.getStyle();
            const loadedAnimation = {
                animationType: navInstance.getAnimationType(),
                animationDuration: navInstance.getAnimationDuration(),
                animationDelay: navInstance.getAnimationDelay(),
            };
            setAnimation(loadedAnimation);
            setAnimationLoaded(true);
            console.log("loadedAnimation", loadedAnimation);
            setMenuItems(loadedMenuItems);
            setCurrentStyle(loadedStyles);
            setNavSettings(navInstance.getSettings());
            console.log("loadedMenuItems", loadedMenuItems);
            if (loadedStyles) {
                Object.entries(loadedStyles).forEach(([className, styles]) => {
                    generateDynamicCSS(className, [styles]);
                });
            }
            
            setIsLoading(false);
        } catch (err) {
            console.error('Failed to load navigation data:', err);
            setError('Failed to load navigation data');
            setIsLoading(false);
        }
    }, [navInstance]);

    // Handle language change from LanguageSwitcher
    const handleLanguageChange = useCallback((newLanguage) => {
        loadNavigationData(newLanguage);
    }, [loadNavigationData]);

    useEffect(() => {
        loadNavigationData(currentLanguage);
    }, [loadNavigationData, currentLanguage]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // if (isLoading) {
    //     return <div className="loading-placeholder">
    //         <Spinner animation="border" role="status">
    //         </Spinner>
    //     </div>;
    // }

    // if (error) {
    //     return <div className="error-message">{error}</div>;
    // }

    // if (!currentStyle) {
    //     return <div className="error-message">No styles available</div>;
    // }

    useEffect(() => {
        if (animationLoaded) {
            setTimeout(() => {
                refreshAosLite();
            }, 50);
        }
    }, [animationLoaded]);


    return (
        <nav className="navbar navbar-expand-lg NavBasic">
            <div 
                className="container NavBasicContainer"
                {...(animationLoaded && animation?.animationType && animation.animationType !== 'none' ? {
                    'data-aos': animation.animationType,
                    'data-aos-duration': Number(animation.animationDuration),
                    'data-aos-delay': Number(animation.animationDelay),
                } : {})}
            >
                <Link className="navbar-brand NavBasicLinkItem" to="/">
                    {navInstance.getLogo() ? <img src={navInstance.getLogo()} alt="Logo" height="50" /> : 'Logo'}
                </Link>
                <button className="navbar-toggler custom-toggler NavBasicToggle" type="button" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} size="lg" />
                </button>
                <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                    <ul className="navbar-nav mx-auto">
                        {menuItems.filter(item => item.type === "link").map((item, index) => (
                            <li className="nav-item Center" key={index}>
                                <Link className="nav-link NavBasicLinkItem" to={item.link}>{item.text}</Link>
                            </li>
                        ))}

                    </ul>
                    <ul className="navbar-nav ">
                            {menuItems.filter(item => item.type === "button").map((item, index) => (
                                <li className="nav-item Center" key={index}>
                                    <CTAPrimaryButton
                                        text={item.button.text}
                                        link={item.button.link}
                                        type={item.button.type}
                                        onClick={() => {
                                            navigate(item.button.link);
                                        }}
                                        className={item.button.className}
                                        style={item.button.style}
                                        navIcon={item.button?.icon ?? null}
                                    />
                                </li>
                            ))}
                            
                            {navSettings.showLanguageSwitcher && (
                                <li className="nav-item Center">
                                    <LanguageSwitcher
                                        onLanguageChange={handleLanguageChange}
                                        variant="outline-light"
                                        size="sm"
                                        showLanguageName={false}
                                        className="ms-3"
                                    />
                                </li>
                            )}
                            {navSettings.showSearch && <NavSearch />}
                        </ul>
                </div>
            </div>
        </nav>
    );
};

export default NavCenter;